import request from '../../../helpers/request';

const createAcceptance = async (values) => {
  const response = await request.post(
    `/FlatsGrid/create_acceptance`,
    values,
    `При создании оповещения о приемке произошла ошибка`
  );

  return response;
};

export default createAcceptance;
